//Reducer Types
interface State {
  staticPagesList: any;
  staticPagesCount: number;
  staticPageDetails: any;
}

export const staticPagesReducer = (
  state: State = {
    staticPagesList: [],
    staticPagesCount: 0,
    staticPageDetails: null,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_STATIC_PAGES": {
      return {
        ...state,
        staticPagesList:
          action?.payload?.page == 1 || !action?.payload?.page
            ? action?.payload?.data
            : [...state?.staticPagesList, ...action?.payload?.data],
        staticPagesCount: action?.payload?.count,
      };
    }
    case "GET_SINGLE_STATIC_PAGES": {
      return {
        ...state,
        staticPageDetails: action?.payload,
      };
    }
    default:
      return state;
  }
};
